import QuestionnaireVisitor from '../QuestionnaireVisitor';
import { isField } from '../structure';
class FilterNodesByApplicationModeVisitor extends QuestionnaireVisitor {
    applicationModes;
    constructor(applicationModes) {
        super();
        this.applicationModes = applicationModes;
    }
    visitFieldGroup(fieldGroup) {
        fieldGroup.fields = this.filterNodesByApplicationMode(fieldGroup.fields);
        super.visitFieldGroup(fieldGroup);
    }
    filterNodesByApplicationMode(nodes) {
        return nodes.filter((node) => this.nodeMatchesApplicationMode(node));
    }
    nodeMatchesApplicationMode(baseNode) {
        if (!isField(baseNode)) {
            return true;
        }
        if (!baseNode.applicationModes?.length) {
            return true;
        }
        return baseNode.applicationModes.some((nodeMode) => this.applicationModes.includes(nodeMode));
    }
}
export function filterNodesByApplicationMode(questionnaire, applicationModes) {
    if (!applicationModes.length) {
        return questionnaire;
    }
    const visitor = new FilterNodesByApplicationModeVisitor(applicationModes);
    const { questionnaire: filteredQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return filteredQuestionnaire;
}
